import React from "react";
import { motion } from "framer-motion";
import { TID } from "../../lib/testIds";

const words =
  "Your Product Does Not Need More Code. It Needs Better Engineering Decisions.".split(" ");

export const ProblemPositioning = () => {
  return (
    <section
      data-testid={TID.problemStatement}
      className="relative bg-[#050505] py-24 md:py-40 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-20" aria-hidden="true" />

      <div className="relative max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="h-px w-8 bg-[#FF5F1F]" />
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#FF5F1F]">
            The Engineering Reality
          </span>
        </div>

        <h2 className="font-headings font-black tracking-tight leading-[1.05] text-white text-3xl sm:text-5xl md:text-6xl lg:text-7xl">
          {words.map((w, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0.15 }}
              whileInView={{ opacity: w === "Better" || w === "Engineering" || w === "Decisions." ? 1 : 0.85 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className={`inline-block mr-3 ${
                w === "Better" || w === "Engineering" || w === "Decisions."
                  ? "text-[#FF5F1F]"
                  : ""
              }`}
            >
              {w}
            </motion.span>
          ))}
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 max-w-3xl text-base md:text-lg text-zinc-400 leading-relaxed"
        >
          Modern software products are increasingly complex. AI must connect with real data,
          workflows, permissions, and business logic. SaaS platforms must scale without becoming
          impossible to maintain. Legacy systems must evolve without putting existing revenue at
          risk. Product teams must move faster without creating tomorrow&apos;s technical debt. That is
          where Techovarya works best — combining product thinking, software architecture, AI
          engineering, cloud infrastructure, and hands-on development.
        </motion.p>
      </div>
    </section>
  );
};
